// The `modalRel` values that open the History modal. Lives outside `History/index.tsx` so that
// Application's lazy-mount gate can read it without pulling History into the main bundle
// (PLAY-5251 design D4).
export const OPEN_MODAL_RELS = ["games-round-history.links", "wallet-transactions", "games-round-history"];
